import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <section {...{
      "className": "section-lead"
    }}><p parentName="section">{`Updates the `}<a parentName="p" {...{
          "href": "/api/../api/projects/stores"
        }}>{`Store`}</a>{` the order is assigned to. It should be used to migrate existing orders to a newly introduced store. Therefore no validations are performed (such as that the customer is allowed to create orders in the store).`}</p>
      <ul parentName="section">
        <li parentName="ul"><inlineCode parentName="li">{`action`}</inlineCode>{` - String - `}<inlineCode parentName="li">{`"setStore"`}</inlineCode></li>
        <li parentName="ul"><inlineCode parentName="li">{`store`}</inlineCode>{` - `}<a parentName="li" {...{
            "href": "/api/../api/types#resourceidentifier"
          }}>{`ResourceIdentifier`}</a>{` to a `}<a parentName="li" {...{
            "href": "/api/../api/projects/stores#store"
          }}>{`Store`}</a>{` - Optional`}</li>
      </ul>
      <p parentName="section">{`This update action produces an `}<a parentName="p" {...{
          "href": "/api/../api/projects/messages#order-store-set"
        }}>{`OrderStoreSet`}</a>{` Message.`}</p>
    </section>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      